module.exports = __webpack_public_path__ + "8d585909039336d5e048fbe5e1b70397.svg";